import React from 'react'

export default () => {
  return (
    <div className="m-4">
      <h5>
        <b>
          Home Language Survey for all identified EL and Immigrant students from
          PreK – 12
        </b>
      </h5>
      <a href="#instructions" data-toggle="collapse">
        Instructions
      </a>
      <ol id="instructions" className="collapse">
        <li>
          Only LEA staff should complete the Home Language Survey form.
          Parents/guardians and students should not access this form.
        </li>
        <li>
          All fields indicated as required must be completed in order to submit
          a record.
        </li>
        <li>
          LEA staff should contact Heidi Jo Bartlett (
          <a href={'HeidiJo.Bartlett@vermont.gov'}>
            HeidiJo.Bartlett@vermont.gov
          </a>
          ) with questions or concerns about the process described above.
        </li>
      </ol>
    </div>
  )
}
